import React from 'react';
import { Container } from '@groupelacentrale/contact-storybook';
import { Link } from 'react-router-dom';
import { ResetPasswordForm } from 'components';
import { ROUTES } from 'routes';
import { usePageTracking } from 'hooks';
import { TRACKING_PAGES } from 'api';

export const ResetPasswordPage: React.FC = () => {
  usePageTracking(TRACKING_PAGES.RESET_PASSWORD);

  return (
    <Container shadowed paddings="mediumP" backgroundColor="bgWhite">
      <ResetPasswordForm />
      <p>
        <Link to={ROUTES.login}>Retour à la connexion</Link>
      </p>
    </Container>
  );
};
